import state from "@/store/modules/customer-profile/state";
import actions from "@/store/modules/customer-profile/actions";
import mutations from "@/store/modules/customer-profile/mutations";
import getters from "@/store/modules/customer-profile/getters";

export default {
    state,
    actions,
    mutations,
    getters
}